<template>
	<div class="f-fieldset" v-if="field">
		<fieldset class="st-form__fieldset st-form__fieldset" :class="'st-form__fieldset--'+level" :name="(field.name ? field.name : '')">
			<div v-if="level == 0">
				<legend v-if="field.title" class="st-form__legend">{{ $t(field.title) }}</legend>
				<div class="row st-form__row" v-for="field in field.fields" :key="field.name">
					<div class="col-xs-12 col-md-4 col-lg-3">
						<label class="st-label st-label--image" :class="{ 'st-label--required': field.required}" for="image">{{ $t(field.title) }}</label>
					</div>
					<div class="col-xs-12 col-md-8 col-lg-9">
						<div ref="fields" :is="'f-' + field.type" :level="level+1" :field="field"></div>
						<div class="st-form__description" v-if="field.description">
							{{ $t(field.description) }}
						</div>
					</div>
				</div>
			</div>
			<div v-else class="row">
				<div class="col-xs-12 col-sm-6" v-for="field in field.fields" :key="field.name">
					<div ref="fields" :is="'f-' + field.type" :level="level+1" :field="field"></div>
				</div>
			</div>
		</fieldset>
	</div>
</template>

<script>



import FFiles 				from '@/components/form/f-files';

import FEmailDomain 		from '@/components/form/f-email_domain';

import FCheckbox 			from '@/components/form/f-checkbox';
// Vue.component('f-checkbox', 		FCheckbox);
import FContactRepeater 	from '@/components/form/f-contact-repeater';
// Vue.component('f-contact-repeater', FContactRepeater);
import FEmail 				from '@/components/form/f-email';
// Vue.component('f-email', 			FEmail);
import FImage 				from '@/components/form/f-image';
// Vue.component('f-image', 			FImage);
import FPassword 			from '@/components/form/f-password';
// Vue.component('f-password', 		FPassword);
import FSelect 				from '@/components/form/f-select';
// Vue.component('f-select', 			FSelect);
import FText 				from '@/components/form/f-text';
// Vue.component('f-text', 			FText);
import FTextarea 			from '@/components/form/f-textarea';
// Vue.component('f-textarea', 		FTextarea);
import FDatetimeLocal 		from '@/components/form/f-datetime-local';
// Vue.component('f-datetime-local', 	FDatetimeLocal);
import FUserSlides 			from '@/components/form/f-user-slides';
// Vue.component('f-user-slides', 		FUserSlides);
import FMapMarker 			from '@/components/form/f-map-marker';
// Vue.component('f-map-marker', 		FMapMarker);

export default {
	name: 'f-fieldset',
	components: {
		FFiles,
		FEmailDomain,
		FCheckbox,
		FContactRepeater,
		FEmail,
		FImage,
		FPassword,
		FSelect,
		FText,
		FTextarea,
		FDatetimeLocal,
		FUserSlides,
		FMapMarker,
	},
	props: {
		level: {
			type: Number,
			default: 0
		},
		field: {
			type: Object,
			default(){
				return {};
			}
		}
	},
	methods: {
		validateErrors(errors){
			let success = true;
			errors.forEach(result => {
				if(typeof result === 'object') {
					const childres = this.validateErrors(result);
					if(childres !== true) success = false;
				} else {
					if(result !== true) success = false;
				}
			});

			return success;
		},
		validate(){
			const self = this;
			return new Promise((resolve, reject) => {

				let promises = [];
				for (let child in self.$refs.fields) {
		        	promises.push(self.$refs.fields[child].validate());
		      	}

		      	Promise.all(promises)
				.then((errors) => {
					let success = self.validateErrors(errors);

					if(success) {
						resolve(errors);
					} else {
						reject(errors);

					}
				}).catch(err => {
					reject(err);
				});
			});
		}
	}
}
</script>

<style scoped>
.st-form__description {
    opacity: .7;
}
.st-form__description:hover {
    opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/form/f-fieldset.vue